import React from "react";

import "@styles/c-toggle.scss";

interface Props {
  checked: boolean;
  onChange: () => void;
}

interface State {}

export class ToggleComponent extends React.Component<Props, State> {

  render() {
    const { checked, onChange } = this.props;
    return (
      <span className="c-toggle">
        <input
          className="c-toggle__checkbox"
          type="checkbox"
          checked={checked}
          onChange={onChange}
        />
        <span className="c-toggle__slider" />
      </span>
    );
  }
}
